export default __webpack_public_path__ + "static/media/Sanathan_Textiles_Earnings_Call_Transcript_q3.9e2c5635.pdf";